// Política de scroll al navegar (G4, cierre F1, QA DOC-49). Pura y testeable.

/** ¿La navegación lleva a otra pantalla y debe abrir arriba? Atrás/adelante (POP) y los
 *  cambios de filtros en la misma ruta no mueven la página. */
export function shouldResetScroll(
  fromPath: string,
  toPath: string,
  navigationType: string,
): boolean {
  return navigationType !== 'POP' && fromPath !== toPath;
}

/** Clave del `state` con que el botón "Volver" pide recuperar la posición del origen. */
export const RESTORE_SCROLL_STATE = 'restoreScrollOf';

const MAX_KEY_LENGTH = 64;

/** Entrada del historial cuya posición se recupera al llegar, o null. */
export function restoreKeyOf(state: unknown): string | null {
  if (typeof state !== 'object' || state === null || !(RESTORE_SCROLL_STATE in state)) {
    return null;
  }
  const key: unknown = (state as Record<string, unknown>)[RESTORE_SCROLL_STATE];
  return typeof key === 'string' && key !== '' && key.length <= MAX_KEY_LENGTH ? key : null;
}
